export default __webpack_public_path__ + "static/media/Tanya.ffe8dc0b.jpeg";